import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { USER_ROLES, VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Button from '../../components/Button'
import { USER_PATH, addUser } from '../../api/userApi'
import RolePicker from '../../components/user/RolePicker'
import { translateRole } from '../../utils/translator'

const UserAddPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [newEntity, setNewEntity] = useState({
        username: "",
        fullName: "",
        password: "",
        hireDate: "",
        exitDate: "",
        role: null
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${USER_PATH}`, true)

    const onClickSubmit = () => {
        addUser(newEntity)
            .then(res => {
                closeTab()
                toast.success('Kullanıcı kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    useEffect(() => {
        setErrors(prevState => ({ ...prevState, role: undefined }))
    }, [newEntity.role])

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Kullanıcı</label>
                <Input
                    label='Kullanıcı Adı'
                    name='username'
                    placeholder='Kullanıcı adı girin...'
                    error={errors.username}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='Şifre'
                    name='password'
                    placeholder='Şifre girin...'
                    error={errors.password}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='Ad Soyad'
                    name='fullName'
                    placeholder='Ad soyad girin...'
                    error={errors.fullName}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='İşe Giriş Tarihi'
                    name='hireDate'
                    type='date'
                    error={errors.hireDate}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <Input
                    label='İşten Çıkış Tarihi'
                    name='exitDate'
                    type='date'
                    error={errors.exitDate}
                    onChange={e => onChange(e, setNewEntity, setErrors)}
                />
                <RolePicker
                    label="Kullanıcı Rolü"
                    value={newEntity.role}
                    onChange={(role) => setNewEntity(prevState => ({ ...prevState, role }))}
                    text={translateRole(newEntity.role) || 'Kullanıcı rolü seçin'}
                    items={USER_ROLES}
                    error={errors.role}

                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default UserAddPage